export default {
  set(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    const expires = `; expires=${date.toUTCString()}`;

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },
};
